import { Link } from 'gatsby'
import React, { Fragment } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Division, RealEstateDataPageComponentData } from 'types'

interface ExternalProps {
  divisions: Division[]
}

const MainMenu_1 = ({
  paragraph = 'Un servicio superior y personalizado de gestión inmobiliaria',
  divisions,
}: RealEstateDataPageComponentData & ExternalProps) => {
  return (
    <>
      <Row className="bg-dark text-center align-items-center vh-100 position-relative">
        <Col className="justify-content-center d-flex">
          <h1 className="w-75 ">{paragraph}</h1>
        </Col>
      </Row>
      <div className="d-flex position-absolute bottom-0 mb-5 justify-content-center w-100">
        <div className="d-inline-flex align-items-center justify-content-center border py-2">
          {divisions.map(({ path, title }, index) => (
            <Fragment key={index}>
              {index ? <h3 className="text-white"> | </h3> : ''}
              <Link
                to={path}
                className="text-decoration-none"
              >
                <h3 className="text-center text-white text-uppercase px-5">{title}</h3>
              </Link>
            </Fragment>
          ))}
        </div>
      </div>
    </>
  )
}

export default MainMenu_1
